import React from 'react';
import i18n from '../../../../i18n';
import { SideBar } from '../../components/Sidebar/Sidebar';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import HeaderBanner from '../../../common/HeaderBanner';
import { formatDate } from '../../../../utils/common';
import { deleteGroup, getGroups } from './services/groupServices';
import {
  AlertTriangle,
  Download,
  Edit,
  Expand,
  FileSpreadsheet,
  Plus,
  Printer,
  Shrink,
  Trash,
} from 'lucide-react';
import Tooltip from '../../../common/Tooltip';
import { withRouter } from '../../../../hoc/withRouter';
import FilterSection from '../../../common/Filter';
import Select from 'react-select';
import { getOrganizationList } from '../../../../models/organization';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { getGroupsList } from '../../../../models/groups';
import { toast } from 'react-toastify';
import { ConfirmModal } from '../../../common/ConfirmModal';
import NewDropdown from '../../../common/NewDropDown';
import { downloadFile } from '../../../../utils/downloadFile';
import { apiUrl } from '../../../../constants/global';
import { getLoggedUser } from '../../../../state/user';

const user = getLoggedUser();

class GroupList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        startDate: null,
        endDate: null,
        client: null,
        group: null,
      },
      groups: [],
      grouplist: [],
      clients: [],
      isLoading: false,
      limit: 15,
      page: 1,
      total: 0,
      showDelete: false,
      selectedGroupId: null,
      exportLoading: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;
    const search = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      client: params.get('client') || null,
      group: params.get('group') || null,
    };

    this.setState({ search, page, limit }, () => {
      this.getAllOrganizationList();
      this.getAllGroupList();
      this.loadGroups();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async loadGroups() {
    this.setState({ isLoading: true });
    let { limit, page } = this.state;
    let { startDate, endDate, client, group } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;
    if (client) q.client = client;
    if (group) q.group = group;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getGroups(q);
    if (response.success) {
      let groups = response.data;
      let { total } = response.meta;

      this.setState({
        groups,
        total,
        isLoading: false,
      });
    }
    this.setState({ isLoading: false });
  }

  async getAllOrganizationList() {
    const response = await getOrganizationList();
    let data = response.data;
    const clients = data.map((item) => {
      return {
        value: item.id,
        label: item.organization_name,
      };
    });
    this.setState({ clients });
  }

  async getAllGroupList() {
    this.setState({ grouploading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let data = response.data;
      const grouplist = data.map((item) => {
        return {
          value: item.id,
          label: item.group_name,
        };
      });
      this.setState({ grouplist, groupLoading: false });
    } else {
      this.setState({ grouplist: [], grouploading: false });
    }
  }

  submitDelete = async () => {
    const { selectedGroupId } = this.state;
    if (!selectedGroupId) return;
    this.setState({ deleteLoading: true });
    try {
      const response = await deleteGroup(selectedGroupId);
      if (response.success) {
        this.setState({
          showDelete: false,
          selectedGroupId: null,
        });
        this.loadGroups();
        toast.success('Group deleted successfully');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error('Error fetching auctions:', error);
      toast.error(error.message);

      // Optionally show error toast/message
    } finally {
      this.setState({ deleteLoading: false, showDelete: false, selectedGroupId: null });
    }
  };
  handleEdit = (row) => {
    this.props.navigate(`/groups/edit/${row.id}`);
    // this.props.navigate(`/edit_group/${row.id}`);
  };
  handleCreate = () => {
    this.props.navigate(`/groups/create`);
  };

  handleDelete = (row) => {
    this.setState({ selectedGroupId: row.id, showDelete: true });
  };
  getColumns = () => {
    return [
      {
        name: i18n.t('id'),
        width: '90px',
        wrap: true,
        cell: (row) => row.id,
      },
      {
        name: i18n.t('image'),
        width: '80px',
        cell: (row) => {
          return (
            <a href={row.image} target="_new">
              <img src={row.group_image_url} style={{ width: 'auto', height: '30px' }} alt="" />
            </a>
          );
        },
      },
      {
        name: i18n.t('client_name'),
        width: '140px',
        wrap: true,
        center: true,
        cell: (row) => (row.organization_deatils ? row.organization_deatils.organization_name : ''),
      },
      {
        name: i18n.t('auctions'),
        width: '90px',
        wrap: true,
        center: true,
        cell: (row) => `(${row.auctions_count})`,
      },
      {
        name: i18n.t('group_name'),
        minWidth: '160px',
        cell: (row) => row.group_name,
      },
      {
        name: i18n.t('group_name_ar'),
        minWidth: '180px',
        cell: (row) => row.group_name_ar,
      },
      {
        name: i18n.t('reg_start_date'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value">{formatDate(row.reg_start_date)}</span>
        ),
      },
      {
        name: i18n.t('reg_end_date'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value">{formatDate(row.reg_end_date)}</span>
        ),
        wrap: true,
      },
      {
        name: i18n.t('start_date'),
        width: '120px',
        cell: (row) => <span className="highlight-table-value">{formatDate(row.start_date)}</span>,
        wrap: true,
      },
      {
        name: i18n.t('end_date'),
        width: '120px',
        cell: (row) => <span className="highlight-table-value">{formatDate(row.end_date)}</span>,
        wrap: true,
      },

      {
        name: i18n.t('Actions'),
        width: '100px',
        center: true,
        cell: (row) => (
          <div className="table-row">
            <Tooltip
              icon={Edit}
              tooltipText={i18n.t('edit')}
              onClick={() => this.handleEdit(row)}
              size={16}
              className="primary-color"
            />
            {row.can_delete && (
              <Tooltip
                icon={Trash}
                tooltipText={i18n.t('delete')}
                onClick={() => this.handleDelete(row)}
                size={16}
                className="danger-color"
              />
            )}
          </div>
        ),
      },
    ];
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = {
          ...prevState.search,
          [name]: value,
          // Clear group when client changes or is cleared
          ...(name === 'client' && { group: null }),
        };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client' && value) {
          // Only load if client has value
          this.getAllGroupList();
        }
      }
    );
  };

  handleSearch = () => {
    this.loadGroups();
  };

  handleClear = () => {
    const defaultSearch = {
      startDate: null,
      endDate: null,
      client: null,
      group: null,
    };

    this.setState({ search: defaultSearch, page: 1 }, () => {
      this.getAllGroupList();
      this.loadGroups();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.loadGroups();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.loadGroups();
    });
  };

  handleDownload = async (fileType) => {
    this.setState({ exportLoading: true });
    try {
      const { startDate, endDate, client, group } = this.state.search;

      // SAME filters as getGroups, but WITHOUT page & limit
      const params = {
        fileType,
      };

      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (client) params.client = client;
      if (group) params.group = group;
      await downloadFile({
        url: `${apiUrl}v2/report/groups`,
        params,
        token: user.token,
        fileType,
        fileName: 'Groups_Report',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  render() {
    const { groups, isLoading, clients, grouplist, deleteLoading, showDelete, exportLoading } =
      this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('group_list')} subtitle={i18n.t('group_list_subtitle')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient"
                        onClick={() => this.handleCreate()}
                      >
                        {<Plus size={18} />}
                        <span>{i18n.t('create_group')}</span>
                      </button>
                      <NewDropdown
                        label={i18n.t('export')}
                        loading={exportLoading}
                        icon={Download}
                        items={[
                          {
                            label: i18n.t('excel'),
                            icon: FileSpreadsheet,
                            onClick: () => this.handleDownload('excel'),
                          },
                          {
                            label: i18n.t('pdf'),
                            icon: Printer,
                            disabled: true,
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    <FilterSection
                      loading={isLoading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Start Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="startDate"
                          type="date"
                          name="startDate"
                          value={this.state.search.startDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" " // Important: single space for floating effect
                        />
                        <label htmlFor="startDate" className="floating-label">
                          {i18n.t('start_date')}
                        </label>
                      </div>

                      {/* End Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="endDate"
                          type="date"
                          name="endDate"
                          value={this.state.search.endDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder={i18n.t('end_date')}
                        />
                        <label htmlFor="endDate" className="floating-label">
                          {i18n.t('end_date')}
                        </label>
                      </div>
                      {/* Client Dropdown */}
                      <div className="react-select-wrapper">
                        <Select
                          options={clients}
                          value={clients.find((c) => c.value === this.state.search.client) || null}
                          onChange={(selectedOption) => {
                            const clientValue = selectedOption ? selectedOption.value : null;
                            this.setState(
                              (prevState) => ({
                                search: {
                                  ...prevState.search,
                                  client: clientValue,
                                  group: null,
                                },
                                grouplist: [],
                              }),
                              () => {
                                if (clientValue) {
                                  this.getAllGroupList();
                                }
                              }
                            );
                          }}
                          name="client"
                          styles={selectStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          placeholder={i18n.t('select_client')}
                          className=""
                        />
                        {/* Only show label when there's a selected value */}

                        <label className="react-select-label">{i18n.t('client_name')}</label>
                      </div>
                      {/* Group Dropdown */}
                      <div className="react-select-wrapper">
                        <Select
                          options={grouplist}
                          value={grouplist.find((c) => c.value === this.state.search.group) || null}
                          onChange={(selectedOption) => {
                            this.setState((prevState) => ({
                              search: {
                                ...prevState.search,
                                group: selectedOption ? selectedOption.value : null,
                              },
                            }));
                          }}
                          name="group"
                          styles={selectStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          placeholder={i18n.t('search_group')}
                          isLoading={this.state.groupLoading}
                          isDisabled={this.state.groupLoading}
                          className=""
                        />
                        {/* Only show label when there's a selected value */}

                        <label className="react-select-label">{i18n.t('group')}</label>
                      </div>
                    </FilterSection>
                    <div className="Data-Listing">
                      {isLoading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : groups.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={groups}
                          customStyles={tableStyles}
                          highlightOnHover
                          pointerOnHover
                          onRowClicked={this.handleEdit}
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_groups_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.loadGroups.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ConfirmModal
          show={showDelete}
          onClose={() => this.setState({ showDelete: false, selectedGroupIdId: null })}
          title={'Confirm Group Deletion'}
          titleIcon={<AlertTriangle size={22} color="#dc3545" />}
          message={'Are You Sure You Want to Delete This Group?'}
          onConfirm={this.submitDelete}
          onCancel={() => this.setState({ showDelete: false, selectedGroupId: null })}
          confirmText={'Delete'}
          cancelText="Cancel"
          loading={deleteLoading}
        ></ConfirmModal>
      </React.Fragment>
    );
  }
}
export default withRouter(GroupList);
